import React from 'react';
import '../less/cash_proceeds.less';
import FAQStorybook from '@abank/abank-faq';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import tariffsData from '../enums/tariffs_data.json';
import serviceUsageItems from '../enums/service_usage_items.json';
import serviceDepositItems01 from '../enums/service_deposit_items_01.json';
import serviceDepositItems02 from '../enums/service_deposit_items_02.json';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
  const page = "cash-proceeds";

  const imagesMap = {
    advantages_img_1,
    advantages_img_2
  }

  const hero_data = {
    title: 'CASH_PROCEEDS_HERO_TITLE',
    text: 'CASH_PROCEEDS_HERO_TEXT',
  }
  
  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  const renderServiceDeposit = ({ title, subtitle, text, items }) => {
    return (
      <div className="service-deposit">
        <div className="container">
          <h2 className="service-deposit__title">{this.l10n(title)}</h2>
          <div className="service-deposit__subtitle">{this.l10n(subtitle)}</div>
          <div className="service-deposit__row">
            {items.map((item, index) => (
              <div key={index} className="service-deposit__item item-service-deposit">
                <h3 className="item-service-deposit__title">{this.l10n(item.title)}</h3>
                <ul className="item-service-deposit__list">
                  {item.list.map((listItem, listIndex) => (
                    <li key={listIndex}>{this.l10n(listItem)}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="cash-proceeds">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <Advantages
              items={advantagesItems}
              title={'CASH_PROCEEDS_ADVANTAGES_TITLE'}
            />
            <div className="audience">
              <div className="container">
                <h2 className="audience__title">{this.l10n('CASH_PROCEEDS_AUDIENCE_TITLE')}</h2>
                <div className="audience__body">
                  <div className="audience__item">{this.l10n('CASH_PROCEEDS_AUDIENCE_ITEM_TEXT_01')}</div>
                  <div className="audience__item">{this.l10n('CASH_PROCEEDS_AUDIENCE_ITEM_TEXT_02')}</div>
                </div>
              </div>
            </div>
            {renderServiceDeposit({
              title: 'CASH_PROCEEDS_SERVICE_DEPOSIT_YUO_TITLE',
              subtitle: 'CASH_PROCEEDS_SERVICE_DEPOSIT_YUO_SUBTITLE',
              items: serviceDepositItems01
            })}
            {renderServiceDeposit({
              title: 'CASH_PROCEEDS_SERVICE_DEPOSIT_FOP_TITLE',
              subtitle: 'CASH_PROCEEDS_SERVICE_DEPOSIT_FOP_SUBTITLE',
              items: serviceDepositItems02
            })}
            <Tariffs
              items={tariffsData}
              title={'CASH_PROCEEDS_TARIFFS_TITLE'}
              alignItems="start"
            />
            <div className="service-usage">
              <div className="container">
                <h2 className="service-usage__title">{this.l10n('CASH_PROCEEDS_SERVICE_USAGE_TITLE')}</h2>
                <div className="service-usage__body">
                  {serviceUsageItems.map((item, index) => (
                    <div key={index} className="service-usage__item item-service-usage">
                      <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                      <div className="item-service-usage__text">{this.l10n(item.text)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <QuestionsAdminNew
              page={page}
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'CASH_PROCEEDS_QUESTIONS_TITLE'}
            />
          </>
        ) : (
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('CASH_PROCEEDS_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('CASH_PROCEEDS_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        )}
      </div>
    </div>
  )
}
